import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import { Virtual } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { availableLodging, clockOutableStaff, emptyLodgingCount, unUpgradedLodgingIndexes } from '../../../../Game/GamePlayerInfo';
import { PIRATES, SEEKERS, VANGUARDS } from '../../../Common/CardUtilities';
import { getCardTextureId, getTextureUrl } from '../../../Common/TextureTools';


import '../../../Choices/lodging-action.css';
import { FateBringsYou } from '../../../Choices/FateBringsYou';
import { ASSETS_URL } from '../../../../../Settings';

class CurrentFate extends Component {
    render() {
        let fate = Array(this.props.gamePlayerData.current_fate).fill(this.props.texture);
        return <>
            <div className={''}>
                <Swiper
                    slidesPerView={6}
                    spaceBetween={0}
                    modules={[ Virtual ]}
                    // className="action-scroller-swiper"
                >
                    {fate.map((targetTextureId, targetIndex) => {
                        return <SwiperSlide key={`t-${targetIndex}`}
                                            virtualIndex={targetIndex}>
                            <img
                                src={getTextureUrl(targetTextureId)}
                                alt="target"
                                // className={'draft-card-img'}
                            />
                        </SwiperSlide>;
                    })}
                </Swiper>
            </div>
        </>;
    }
}



export default class AntiJuice2d extends Component {
    STAFF_TEXTURE_ID = 157;

    constructor(props) {
        super(props);
        this.api = this.props.app.game.seatedController.gamePlayerApi;

        const cardId = this.props.gamePlayerData.current_attacking_card;
        const cardTexture = getCardTextureId(cardId);
        let attackTexture;

        if (PIRATES.includes(cardId)) {
            attackTexture = 129; // snohe
        } else if (SEEKERS.includes(cardId)) {
            attackTexture = 76;
        } else if (VANGUARDS.includes(cardId)) {
            attackTexture = 72;
        } else if (cardId == null) {
            // Opponent Ghost/Lodging attack defense (Manual §8.2.2). There is
            // NO attacking guest card — current_attacking_card is null and the
            // attack type rides on current_action instead (engine Action ids:
            // GHOST=6, LODGING=2). Show the matching icon. Must never
            // early-return without setting this.state: a direct attack sends a
            // null card, and the old `return` left state undefined and crashed
            // render() the instant a human opened the defensive Clock-Out.
            attackTexture =
                this.props.gamePlayerData.current_action === 2
                    ? 72   // lodging permit — a Lodging attack removes permits
                    : 76;  // ghost — a Ghost attack queues ghosts
        } else {
            console.error('Invalid attacking card.');
            return;
        }

        this.state = {
            sellableRobots: [],
            soldRobots: [],
            startingFate: 0,
            currentFate: 0,
            texture: getTextureUrl(attackTexture),
            textureId: attackTexture,
            staffTexture: getTextureUrl(this.STAFF_TEXTURE_ID),
        }
    }

    componentDidMount() {
        this.setState({
            sellableRobots: clockOutableStaff(this.props.gamePlayerData),
            startingFate: this.props.gamePlayerData.current_fate,
            currentFate: this.props.gamePlayerData.current_fate,
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // if the board has changed, reset.
        if (clockOutableStaff(this.props.gamePlayerData).length >
            (this.state.sellableRobots.length + this.state.soldRobots.length)) {
            this.resetStaff();
        }
    }

    actionImage = (props) => {
        if (props.texture === this.STAFF_TEXTURE_ID) {
            return this.staffImage(props);
        }

        let isPurchased = (props.index + 1 > this.state.startingFate);

        return <div>
            <img
                src={this.state.texture}
                alt="action"
                // className={'inventory-selector-image'}
            />

            {isPurchased &&
                <div className={'purchased-action-container'}>
                    <div className={'purchased-action-parent'}>
                        <div className={'purchased-action-robot-container'}>
                            <img
                                src={this.state.staffTexture}
                                alt="robot"
                                className={'purchased-action-robot'}
                            />
                        </div>
                    </div>
                </div>
            }
        </div>
    };

    staffImage = (props) => {
        return <div>
            <img
                src={this.state.staffTexture}
                alt="action"
                // className={'inventory-selector-image'}
            />
        </div>
    };

    onStaffClick = () => {
        let sellableRobots = this.state.sellableRobots;
        let soldRobot = sellableRobots.pop()
        let newFate = this.state.currentFate - 2;
        if (newFate < 0) newFate = 0;
        this.setState({
                sellableRobots: sellableRobots,
                soldRobots: [...this.state.soldRobots, soldRobot],
                currentFate: newFate,
            },
            this.showLodgingUpgrades);
    }

    resetStaff = () => {
        this.setState({
            sellableRobots: [...this.props.receivedMessage.package.data.sellable_robots],
            soldRobots: [],
            currentFate: this.state.startingFate,
        }, this.showLodgingUpgrades);
    }

    onSwiperClick = (swiper) => {
        let swiperData = this.getSwiperData();
        let index = swiper.clickedIndex;
        if (this.state.soldRobots.length > 0 && index === 0) {
            // if it is the reset button press it, else bump everything one.
            return this.resetStaff();
        }

        if (this.state.currentFate === 0 && index === 0) {
            // This is the DONE button.
            return this.api.clickAntiJuice(this.state.soldRobots);
        }

        if (this.state.soldRobots.length > 0  && index === 1) {
            // This is the done button.
            return this.api.clickAntiJuice(this.state.soldRobots);
        }

        if (this.state.soldRobots.length > 0) index--;  // reset
        if (this.state.currentFate === 0) index--;  // done

        let item = swiperData[index];
        if (!item) return;  // stop if bad index
        if (item === 157) {  // click robot
            this.onStaffClick();
        } else {  // click action
            this.api.clickAntiJuice(this.state.soldRobots);


        }
    }

    getSwiperData = () => {
        let selectors = Array(this.state.currentFate).fill(this.state.textureId);
        let robots = Array(this.state.sellableRobots.length).fill(157);
        return [...selectors, ...robots];
    }

    render() {
        return <>
            <div>
                <FateBringsYou
                    currentFate={this.state.currentFate}
                    factionId={this.props.gamePlayerData.faction}
                    type={'Attacks'} />
                <div className={'lodging-action-anchor'} id={'juicer'}>
                    <img
                        src={`${ASSETS_URL}overlays/AntiJuiceOverlay-1080x210.png`}
                        alt="action"
                        className={'lodging-action-background'}
                    />
                    <div className={'lodging-action-flex'}>
                        <div className={'lodging-action-flex-item'}>
                            <Swiper
                                slidesPerView={6}
                                spaceBetween={0}
                                freeMode={true}
                                grabCursor={true}

                                modules={[Virtual]}

                                onSwiper={(swiper) => {
                                    this.swiper = swiper;
                                }}
                                onClick={this.onSwiperClick}
                                // className="action-scroller-swiper"
                            >
                                {this.state.soldRobots.length > 0 &&
                                    <div className={'lodging-action-flex-button'}>
                                        <SwiperSlide key={`gi-${-1}`}
                                                     virtualIndex={-1}>
                                            <button className={'reset-button'} >Reset</button>
                                            <img
                                                src={'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='}
                                                alt="reset"
                                                className={'reset-image'}
                                            />
                                        </SwiperSlide>
                                    </div>
                                }
                                {this.state.currentFate === 0 &&
                                    <div className={'lodging-action-flex-button'}>
                                        <SwiperSlide key={`gi-${-2}`}
                                                     virtualIndex={-2}>
                                            <button className={'reset-button'} >Done</button>
                                            <img
                                                src={'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='}
                                                alt="reset"
                                                className={'reset-image'}
                                            />
                                        </SwiperSlide>
                                    </div>
                                }
                                {this.getSwiperData().map((selector, index) => {
                                    return <SwiperSlide key={`gi-${index}`}
                                                        virtualIndex={index}>
                                        <this.actionImage
                                            texture={selector}
                                            index={index}
                                        />
                                    </SwiperSlide>
                                })}
                            </Swiper>
                        </div>
                    </div>
                </div>
            </div>
        </>
    }
}
